import { h } from 'preact';

import Store from '../../../stores/Store';
import { useEffect, useMemo, useRef, useState } from 'preact/hooks';

import CustomForm from '../../../components/form';
import CustomButton from '../../../components/button';
import FormValidator from 'simple-form-valid';
import { GlobalState } from '../../../states/global-state';
import Validator from '../../../scripts/validator';

import { plotAndCacheFormData, setUpControls, submitForm } from '../utils';

import KycFinancialProfileData from './data';
import FormLayout from '../../../components/layouts/FormLayout';
const KycFinancialProfile = props => {
  const [controls, setControls] = useState([]);
  const store = useMemo(() => new Store(), []);

  const episodeIndex = useRef(3);
  const nextEpisode = useRef('/kyc/pep');
  const formConfig = useRef(KycFinancialProfileData);
  const display = useRef(formConfig.current.display);
  const formValidation = useRef(null);

  const formRef = useRef();

  useEffect(() => {
    const config = formConfig.current;

    setControls(setUpControls(formConfig.current.controls));

    plotAndCacheFormData({ config, episodeIndex });

    formValidation.current = new FormValidator(formRef.current, Validator, {
      parentClass: 'form-group',
      errorClass: 'invalid',
      successClass: 'valid',
      errorTextParent: 'form-group',
      errorTextTag: 'div',
      errorTextClass: 'invalid-feedback',
    });
  }, [store]);

  const submitHandler = e => {
    e.preventDefault();

    submitForm({
      e,
      formValidation: formValidation.current,
      formConfig,
      episodeIndex,
      nextEpisode,
    });
  };

  return (
    <FormLayout
      display={display.current}
      path={props.path}
      isReview={props.isReview}
    >
      <CustomForm
        controls={controls}
        onSubmit={submitHandler}
        formRef={formRef}
      >
        <CustomButton
          type="submit"
          class="btn btn-success"
          isLoading={GlobalState.showSpinner.value}
        >
          Update
        </CustomButton>
        &nbsp;&nbsp;
        <CustomButton type="button" class="btn btn-outline-warning">
          Cancel
        </CustomButton>
      </CustomForm>
    </FormLayout>
  );
};

export default KycFinancialProfile;
